// prettier-ignore
export const JackpotActionTypes = {
  SET_CURRENT_JACKPOT_ID: 'SET_CURRENT_JACKPOT_ID',
  SET_JACKPOT_META_DATA: 'SET_JACKPOT_META_DATA',
  SET_INTERNAL_JACKPOTS: 'SET_INTERNAL_JACKPOTS',
  SET_EXTERNAL_JACKPOTS: 'SET_EXTERNAL_JACKPOTS'
};
